import { Injectable } from "@angular/core";
import { PropertyUiPb } from "src/app/com/staybloom/uiproto/property/propertyUiProto";
import { ApiService } from "src/app/_services/apis/api.service";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "src/app/_config/app.config";
import { finalize, Observable, shareReplay } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class PropertyStoreService {
  propertyData: PropertyUiPb | undefined;

  private inFlightRoomCleaningStatus = new Map<string, Observable<any>>();

  constructor(private apiService: ApiService, private http: HttpClient) {}

  async getPropertyData(id: string) {
    this.propertyData = await new Promise((resolve, reject) => {
      this.apiService.getPropertyData(id).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          reject(error);
        },
      });
    });

    return this.propertyData;
  }

  /**
   * In-flight GETs are shared per room id: the reservation-summary page renders two
   * <app-more-action-card> instances (one per breakpoint, both always in the DOM),
   * and each used to fire its own identical request. Only concurrent callers share —
   * the entry is dropped once the request settles, so a fetch after
   * updateRoomCleaningStatus() still hits the network.
   */
  getSingleRoomCleaningStatus(id: string): Observable<any> {
    const inFlight = this.inFlightRoomCleaningStatus.get(id);
    if (inFlight) {
      return inFlight;
    }
    const request = this.http
      .get(AppConfig.API_URL + AppConfig.FRON_END_API.ROOMS_WITH_BACKSLASH + id, {
        headers: { apiName: "room information" },
      })
      .pipe(
        finalize(() => this.inFlightRoomCleaningStatus.delete(id)),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    this.inFlightRoomCleaningStatus.set(id, request);
    return request;
  }

  getRoomCleaningStatus(id: string, obj: any) {
    return this.http.get(AppConfig.API_URL + AppConfig.FRON_END_API.ROOMS, {
      params: {
        query: JSON.stringify(obj),
      },
      headers: { apiName: 'room information' },
    });
  }

  updateRoomCleaningStatus(id: string, data: any) {
    return this.http.put(
      AppConfig.API_URL + AppConfig.FRON_END_API.ROOMS_WITH_BACKSLASH + id,
      data,
      { headers: { apiName: 'room information' } },
    );
  }

  getPropertyAccessForUser(data: any) {
    return this.http.get(AppConfig.API_URL + AppConfig.FRON_END_API.ACCESS_EGC + data);
  }
}
